// Feedback reducer for customer feedback modal
const initialState = {
  isOpen: false,
  submitted: false,
  error: null,
  lastClosed: null,
  closeCount: 0,
  lastSubmitted: null,
  showSuccess: false,
  showError: false,
};

export default function feedbackReducer(state = initialState, action) {
  switch (action.type) {
    case "FEEDBACK_OPEN_MODAL":
      return {
        ...state,
        isOpen: true,
        showSuccess: false,
        showError: false,
      };
    case "FEEDBACK_CLOSE_MODAL":
      return {
        ...state,
        isOpen: false,
        lastClosed: Date.now(),
        closeCount: state.closeCount + 1,
      };
    case "FEEDBACK_SUBMIT_SUCCESS":
      return {
        ...state,
        isOpen: false,
        submitted: true,
        lastSubmitted: Date.now(),
        showSuccess: true,
        showError: false,
      };
    case "FEEDBACK_SUBMIT_ERROR":
      return {
        ...state,
        showError: true,
        error: action.error,
      };
    case "FEEDBACK_RESET":
      return initialState;
    case "FEEDBACK_HIDE_MESSAGES":
      return {
        ...state,
        showSuccess: false,
        showError: false,
        error: null,
      };
    default:
      return state;
  }
}
